module.exports = __webpack_public_path__ + "static/media/activity13.f030bc9b.JPG";